import { faVideo } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button} from 'MaterialUIComponents';
import { React } from 'Imports';
import { isEncompass } from '$Utilities/integrationPlatform';

export const RequestVideoButton = (props: { onClick: () => void, videoRecallPreviewEnabled?: boolean}) => {
    const styles = require('./RequestVideoButton.scss') as {
        requestButtonGeotab: string; //splits OFF
        requestButtonEncompass: string;
        requestVideoButtonGeotab: string; //splits ON
        requestVideoButtonEncompass: string;
    };

    if (props.videoRecallPreviewEnabled === undefined) {
        return <></>;
    }

    if (!props.videoRecallPreviewEnabled) {
        // old/split-OFF behavior
        return (
            <Button
                disableRipple
                aria-label="request"
                className={isEncompass ? styles.requestButtonEncompass : styles.requestButtonGeotab}
                onClick={props.onClick}
            >
                Request <FontAwesomeIcon icon={faVideo} />
            </Button>
        );
    }

    return (
        // new/split-ON behavior
        <Button
            disableRipple
            aria-label="request"
            className={isEncompass ? styles.requestVideoButtonEncompass : styles.requestVideoButtonGeotab}
            onClick={props.onClick}
        >
            Request Video
        </Button>
    );
};
